import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Login from './routers/Login';
import BasicLayout from './Layout';
function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="/login" component={Login} />
        <Route component={BasicLayout} />
      </Switch>
    </Router>
  );
}
export default App;
